import { Component, OnInit, OnDestroy, ElementRef, ViewChild, ChangeDetectorRef } from '@angular/core';
import {  SafeUrl } from '@angular/platform-browser';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { interval, Subject, Subscription, takeUntil } from 'rxjs';
import { recordVideos, SimpleVideo, Video } from 'src/app/models/interviewModel';


import { InterviewVideoApiService } from 'src/app/services/video-recorder/interview-video-api.service'; 
import { VideoRecoderService } from 'src/app/services/video-recorder/video-recoder.service';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { DialogComponent } from 'src/app/components/dialog/dialog.component';
import { DialogModel } from 'src/app/components/dialog/models/DialogModel';





@Component({
  selector: 'app-virtual-interview',
  templateUrl: './virtual-interview.component.html',
  styleUrls: ['./virtual-interview.component.css']
})

export class VirtualInterviewComponent implements OnInit {
  @ViewChild('previewVideo') previewVideo!: ElementRef<HTMLVideoElement>;
  @ViewChild('recordedVideo') recordedVideo!: ElementRef<HTMLVideoElement>;

  
  public videos: SimpleVideo[] = [];
  public currentStep = 1;
  public currentVideoUrl = '';
  public showThankYouMessage = false;
  public countdown = 0;
  public isDisabled = true;
  public Records: recordVideos = {
    title: '',
    duration: 0,
    files: [],
    feedbackResponse:""
  };
  public isRecording=false;
  private videoIndex = 0;
  private countdownInterval: Subscription | null = null;
  private subscriptions = new Subscription();
  public isVideoOn: boolean = false;
  public isMicOn: boolean = false;
  public id:string="";
  public timeUntilRecord:number=0;
  public instructions:string[]=[];
  public feedbackText:string = '';
  public feedbackForm!: FormGroup;

  constructor(
    private videoService: InterviewVideoApiService,
    public recorder: VideoRecoderService,
    public cd:ChangeDetectorRef,
    private fb: FormBuilder,
    private route:Router,
    private dialog: MatDialog
  ) {
    this.initFeedbackForm();
  }

  ngOnInit() {
    this.loadVideos();
    const videoStateSub = this.recorder.isVideoOn$.subscribe(status => this.isVideoOn = status);
    const micStateSub = this.recorder.isMicOn$.subscribe(status => this.isMicOn = status);
    const recordedSub = this.recorder.recordedBlob$.subscribe(record => {
      if (record) { 
       this.Records.files.push(record);
        this.handleRecordingCompletion(); 
      }
    });

    this.subscriptions.add(recordedSub);
  }
  
  ngAfterViewInit() {
    
    const previewSub = this.recorder.previewStream$.subscribe(stream => {
      if (this.previewVideo && this.previewVideo.nativeElement) {
        this.previewVideo.nativeElement.srcObject = stream;
      }
    });
    this.subscriptions.add(previewSub);
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
    if (this.countdownInterval) {
      this.countdownInterval.unsubscribe();
    }
  }
  
  loadVideos(): void {
   
    
    this.videoService.getAdminVideos().subscribe({
      next: (urls) => {
        
        this.getInstructions(urls.description);
        this.videos = urls.videos;
        
        if (this.videos.length > 0) {
          this.currentVideoUrl = this.videos[0].url;
          this.timeUntilRecord=this.videos[0].duration;
          this.interviewTimer(this.timeUntilRecord);
        
         requestAnimationFrame(
          () => this.recordedVideo?.nativeElement.load()
         )
        }
      },
      error: (err) => console.error('Failed to load videos', err)
    });
  }

  toggleVideo() {
    this.recorder.toggleVideoStream();
  }

  toggleMic() {
    this.recorder.toggleAudioStream();
  }

  startRecording() {
    if(this.recorder.isMicOn$.value && this.recorder.isVideoOn$.value){
      this.recorder.startRecording();
      this.isRecording=true;
      this.startCountdown();
    } else {
      this.openDialog({
        status: 'warning',
        title: 'Enable Camera & Microphone',
        content: 'Please enable both camera and microphone before recording',
        okBtnText: 'OK'
      });
    }
  }

  cancelRecording() {
    this.recorder.cancelRecording();
    this.isRecording = false;
    if(this.countdownInterval) {
      this.countdownInterval.unsubscribe();
      this.countdown = 0;
    }
    
    
   
    this.recorder.isRecording$.next(false);
  }

  startCountdown() {
    this.countdown = 5; 
    this.countdownInterval = interval(1000).subscribe(() => {
      this.countdown--;
      if (this.countdown <= 0) {
        if (this.countdownInterval) {
          this.isDisabled=true;
          this.countdownInterval.unsubscribe();
        }
        
       
        this.isRecording = false; 
        this.countdown = 0; 
        this.isVideoOn=false;
        this.isMicOn=false;
     
        this.recorder.stopRecording();
      }
    });
  }
  interviewTimer(duration: number) {
    this.isDisabled = true;
    setTimeout(() => {
      this.isDisabled = false;
      this.cd.detectChanges();
    }, duration * 1000);
  }

  handleRecordingCompletion() {
    console.log("Recording completed");
    console.log("Current video index before update:", this.videoIndex);
  
    this.currentStep++;
  
    if (this.currentStep == 4) {
      this.showThankYouMessage = true;
      
    } else {
      this.videoIndex++;
      if (this.videoIndex >= this.videos.length) {
        this.videoIndex = 0;
      }
      
      this.currentVideoUrl = this.videos[this.videoIndex].url;
      this.timeUntilRecord = this.videos[this.videoIndex].duration;
      
      if (this.recordedVideo?.nativeElement) {
        this.recordedVideo.nativeElement.src = this.currentVideoUrl;
        this.recordedVideo.nativeElement.load();
        this.interviewTimer(this.timeUntilRecord);
      }
    }
    this.cd.detectChanges();
  }
  getInstructions(info:string){
    this.instructions = info.split('\n').filter(line => line.trim() !== '');
  }

  submitFeedback() {
    const feedbackValue = this.feedbackForm.get('feedback')?.value;
    // If feedback is provided, validate it has minimum length
    if (feedbackValue && feedbackValue.trim().length < 10) {
      this.openDialog({
        status: 'warning',
        title: 'Feedback Too Short',
        content: 'Feedback must be at least 10 characters if provided.',
        okBtnText: 'OK'
      });
      return;
    }
    this.Records.feedbackResponse = feedbackValue || '';
    if (this.Records && this.Records.files.length > 0) {
      this.videoService.uploadRecordVideos(this.Records).subscribe({
        next: (response) => {
          console.log('Videos and feedback uploaded successfully:', response);
          this.openDialog({
            status: 'success',
            title: 'Thank You',
            content: 'Thank you for your feedback!',
            okBtnText: 'OK'
          }).afterClosed().subscribe(() => {
            this.feedbackForm.reset();
            this.cd.detectChanges();
            this.route.navigateByUrl("/");
          });
        },
        error: (error) => {
          console.error('Error uploading videos and feedback:', error);
          this.openDialog({
            status: 'error',
            title: 'Upload Failed',
            content: 'Failed to upload. Please try again.',
            okBtnText: 'OK'
          });
        }
      });
    } else {
      console.error('No videos to upload');
      this.openDialog({
        status: 'error',
        title: 'No Videos',
        content: 'No videos to upload',
        okBtnText: 'OK'
      });
    }
  }

  initFeedbackForm() {
    this.feedbackForm = this.fb.group({
      feedback: ['', [Validators.minLength(10)]]
    });
  }

  openDialog(dialog: DialogModel) {
    return this.dialog.open(DialogComponent, {
      width: '400px',
      data: dialog
    });
  }
}

